import React from 'react'
import { Helmet } from 'react-helmet'
import LWCLayout from '../layouts/LWCLayout'

const DataCloudTrail = () => {
  return (
    <LWCLayout slug={'data-cloud-trail'}>
        <Helmet>
          <title>Data 360 Learning Journey</title>
        </Helmet>

        <tm-page>
          <tm-hero-a 
                title="Data 360 Learning Journey"
                subtitle="Complete this journey to build a solid foundation that prepares you for transformational change. Ready to become a Data 360 expert?" 
                img-align="bottom" 
                img-alt="Data 360 Learning Journey icon"
                img-src="https://developer.salesforce.com/resources2/datacloud/block1-hero-img-v2.png" 
                cta-label="Start your journey"
                cta-href="https://trailhead.salesforce.com/content/learn/trails/data-cloud-unlock-the-value-of-your-data"
            />
            
            <tm-section-a 
                background="white" 
                title="Grow your data skills and unlock the full potential of Salesforce Data 360"
            >
            { 
            <div>
              <p>
                The Data 360 Learning Journey is a progressive, 3-part trail experience designed to help you
                confidently build a strong data foundation, apply hands-on skills, and develop advanced
                solutions that drive real business value on Trailhead.              
                <br></br>
                <br></br>
                Each level offers guided Trailhead modules, hands-on practice, and badges that mark your
                progress as you move from foundational understanding to applied expertise.
              </p>
              <br></br>
            </div>

            }

         <tm-card-grid-a img-aspect="60%" img-type="full">
          <tm-grid-item  
            pretitle="[Foundational]" 
            title="Data 360: Unlock the Value of Your Data" 
            description="Explain Data 360 concepts and business impact." 
            cta-title="Get Started" 
            cta-href="https://trailhead.salesforce.com/content/learn/trails/data-cloud-unlock-the-value-of-your-data" 
            cta-target="true">
          </tm-grid-item>
          <tm-grid-item  
            pretitle="[Intermediate]" 
            title="Data 360: Explore Setup to Activation" 
            description="Implement Data 360 solutions to drive measurable business outcomes." 
            cta-title="Get Started" 
            cta-href="https://trailhead.salesforce.com/content/learn/trails/data-cloud-explore-setup-to-activation" 
            cta-target="true">
          </tm-grid-item>
          <tm-grid-item  
            pretitle="[Advanced]" 
            title="Data 360: Develop and Build Solutions" 
            description="Understand advanced concepts and build cross-cloud solutions"
            cta-title="Get Started"
            cta-href="https://trailhead.salesforce.com/content/learn/trails/data-360-develop-and-build-solutions"
            cta-target="true">
          </tm-grid-item>
        </tm-card-grid-a>
                <tm-feature-grid-a>
                        <tm-grid-item 
                            cta-primary-href="https://www.salesforce.com/data/" 
                            cta-primary-target="true" 
                            cta-primary-title="Learn more about Data 360" 
                            description="Data 360 is the only data platform native to the world's #1 AI CRM, and it's deeply embedded in the Einstein 1 Platform. With Data 360, you can unify your enterprise data, harness the power of metadata, and drive AI results to improve customer experiences and drive growth." 
                            img-alt="A screen showing the details of a record in Salesforce" 
                            img-src="https://developer.salesforce.com/resources2/datacloud/block3-1-up-img-what-is-data-cloud.png" 
                            title="Say hello to Data 360"></tm-grid-item>
                        
                        <tm-grid-item 
                            cta-primary-href="https://trailhead.salesforce.com/" 
                            cta-primary-target="true" 
                            cta-primary-title="Learn on Trailhead" 
                            description="You can learn to use any Salesforce product with free, online learning on Trailhead. Build your technical, business, and soft skills with curated content for anyone from admins to developers to business users." 
                            img-alt="A screenshot of Trailhead's homepage" 
                            img-src="https://developer.salesforce.com/resources2/datacloud/block4-1-up-img-skill-up-on-trailhead.png" 
                            title="Learn more about Data 360 and beyond on Trailhead"></tm-grid-item>
                </tm-feature-grid-a>
            </tm-section-a>
            <div class="slds-align_absolute-center slds-container_xx-large" >
              <div>
                <img src="https://developer.salesforce.com/resources2/datacloud/block5-img-landscape-background.png" alt=""></img>
              </div> 
            </div>
        </tm-page>
    </LWCLayout>
  )
}

export default DataCloudTrail